// import { colors } from './../../../../config/styles'

export default {
	container: {
		paddingLeft: 30,
		paddingRight: 30,
		paddingBottom: 15,
	},
	rowStyles: {
		textAlign: 'center',
	},
	rotateButtonWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	rotationButton: {
		width: 'auto',
		marginLeft: 10,
		marginRight: 10,
	},
	rotationIcon: { display: 'block' },
}
